import { render, staticRenderFns } from "./reading-qa.vue?vue&type=template&id=58a7187e&scoped=true"
import script from "./reading-qa.vue?vue&type=script&lang=js"
export * from "./reading-qa.vue?vue&type=script&lang=js"
import style0 from "./reading-qa.vue?vue&type=style&index=0&id=58a7187e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_n4a2vfauuuf6vmcvyn2rbj6bo4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a7187e",
  null
  
)

export default component.exports